import React from 'react';
import moment from 'moment-timezone';

import MDatetimePicker from 'views/MDatetimePicker/MDatetimePicker';

import { DatePickerFormats } from 'utils/enums/time-format';

type Props = {
  disabled?: boolean;
  valid?: boolean;
  invalid?: boolean;
  value: moment.Moment | null;
  showTimeSelect?: boolean;
  dateFormat?: DatePickerFormats;
  minDate?: moment.Moment | null;
  maxDate?: moment.Moment | null;
  className?: string;
  timeIntervals?: number;
  showTimeSelectOnly?: boolean;
  clearButton?: boolean;
  showYearDropdown?: boolean;
  showResetDate?: boolean;
  onChange: (value: moment.Moment | null) => void;
}

const MFormDateTimePickerView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <MDatetimePicker
      disabled={props.disabled}
      valid={props.valid}
      invalid={props.invalid}
      value={props.value}
      showTimeSelect={props.showTimeSelect}
      dateFormat={props.dateFormat}
      minDate={props.minDate}
      maxDate={props.maxDate}
      className={props.className}
      timeIntervals={props.timeIntervals}
      showTimeSelectOnly={props.showTimeSelectOnly}
      onChange={props.onChange}
      showYearDropdown={props.showYearDropdown}
      clearButton={props.clearButton}
      showResetDate={props.showResetDate}
    ></MDatetimePicker>
  );
};

MFormDateTimePickerView.displayName = 'MFormDateTimePickerView';
MFormDateTimePickerView.defaultProps = {};

export default MFormDateTimePickerView;
